import React, { useContext, Fragment } from 'react';
import useSectionStyles from './styles';
import PageContext from '../../contexts/pageContext';
import Carousel from '../../components/carousel';
import Button from '../../components/button';
import NextImageRenderer from '../../components/nextImageRenderer';
import { wordBreakValue } from '../../utils/cssUtils';

function Section({ nodeData, sectionIndex, extraProps }) {
  const {
    layout: { containerWidth },
    isMobile,
    isCustomWebsite,
    countryCode
  } = useContext(PageContext);
  const classes = useSectionStyles({
    isCustomWebsite,
    isMobile,
    wordBreakValue: wordBreakValue(countryCode)
  });

  const handleButton = () => {
    extraProps?.courseBuyNow();
  };

  return (
    <div className={classes.centerData}>
      <div className={classes.imageContainerDiv}>
        <div className={classes.imageContainer}>
          {/* <img
            ref={nodeData?.image?.refSetter}
            className={classes.sideBannerImage}
            src={nodeData.image.metadata.value}
          /> */}

          <NextImageRenderer
            src={nodeData.image.metadata.value}
            ref={nodeData?.image?.refSetter}
            className={classes.sideBannerImage}
            sectionIndex={sectionIndex}
          />

          {/* <div className={classes.imageBorder} /> */}
        </div>
      </div>
      <div className={classes.textContainer}>
        <div className={classes.subTitleHeading}>
          <span
            ref={nodeData?.cardHeading?.refSetter}
            dangerouslySetInnerHTML={{
              __html: nodeData.cardHeading.metadata.value
            }}
          />
        </div>
        <h2 className={classes.heading}>
          <span
            ref={nodeData?.title?.refSetter}
            dangerouslySetInnerHTML={{
              __html: nodeData.title.metadata.value
            }}
          />
        </h2>

        <p
          ref={nodeData?.description?.refSetter}
          className={classes.description}
          dangerouslySetInnerHTML={{
            __html: nodeData.description.metadata.value
          }}
        />
        {nodeData?.cta?.validations?.isEmptyAllowed &&
        nodeData?.cta?.metadata?.value === '' ? null : nodeData?.cta?.metadata
            ?.default === true ? (
          <Button
            data={nodeData.cta.metadata}
            ref={nodeData?.cta?.refSetter}
            type={nodeData?.cta?.metadata?.type}
            size={isMobile ? 'small' : 'medium'}
            onClick={handleButton}
          />
        ) : (
          <Button
            ref={nodeData?.cta?.refSetter}
            data={nodeData.cta.metadata}
            type={nodeData?.cta?.metadata?.type}
            size={isMobile ? 'small' : 'medium'}
            name="button"
          />
        )}
      </div>
    </div>
  );
}

export default function BannerCarouselLeft({
  sectionData,
  isCustomWebsite,
  sectionIndex,
  isMobile,
  extraProps
}) {
  const {
    layout: { containerWidth }
  } = useContext(PageContext);
  const classes = useSectionStyles({ containerWidth });
  const [{ bannerCarousel }] = sectionData.components;
  const Wrapper = bannerCarousel.components.length > 1 ? Carousel : Fragment;
  return (
    <section className={classes.section}>
      <div className={classes.sectionContainer}>
        <Wrapper>
          {bannerCarousel.components.map((node, idx) => (
            <Section
              nodeData={node}
              key={idx /* or some other unique property */}
              sectionIndex={sectionIndex}
              extraProps={extraProps}
            />
          ))}
        </Wrapper>
      </div>
    </section>
  );
}
